import { Office } from '@/models';
import _ from 'lodash';
import Vue from 'vue';
import { MutationTree } from 'vuex';
import { PropertyState } from './types';

export const mutations: MutationTree<PropertyState> = {
};
